<!--suppress ALL -->
<template>
  <div>
    <div class="page case-detail__content">
      <div class="padding15 bg-content m-b-24">
        <div class="m-b-24">
          <el-button type="primary" size="small" @click="addVisable" v-if="this.$hasPerm('H001&01')">添加录音员</el-button>
        </div>
        <div class="bg-content padding15">
          <el-form size="small" label-width="50px" ref="searchRef">
            <el-row :gutter="24">
              <el-col :span="8">
                <el-form-item label="姓名" label-width="140px">
                  <el-input v-model="searchReq.name" clearable placeholder="请输入查询条件"/>
                </el-form-item>
              </el-col>
              <el-col :span="4" :offset="0">
                <div class="text right">
                  <el-button type="primary" size="small" plain @click="getList();"><i class="fa fa-search"></i> 搜索</el-button>
                  <el-button size="small" @click="searchReq.name = null;">重置</el-button>
                </div>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div class="padding15 bg-content">
          <el-table size="small" :data="recorderlist">
            <el-table-column fixed property="name"  label="名字" align="center"/>
            <el-table-column fixed property="supplierName"  label="类型" align="center"/>
            <el-table-column fixed property="recorderNo"  label="编码" align="center"/>
            <el-table-column fixed property="gender"  label="性别" align="center"/>
            <el-table-column fixed property="speechRate"  label="语速" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.speechRate">{{scope.row.speechRate}}</span>
                <span v-else>--</span>
              </template>
            </el-table-column>
            <el-table-column fixed property="pitchRate"  label="语调" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.pitchRate">{{scope.row.pitchRate}}</span>
                <span v-else>--</span>
              </template>
            </el-table-column>
            <el-table-column fixed property="status"  label="状态" align="center">
              <template slot-scope="scope">
                <el-tag type="success" v-if="scope.row.status === 1">开启</el-tag>
                <el-tag type="danger" v-else>关闭</el-tag>
              </template>
            </el-table-column>
            <el-table-column fixed property="createTime" label="添加时间"  align="center"/>
            <el-table-column fixed label="操作" align="center">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="updateVisiable(scope.row)"><i class="el-icon-edit-outline"></i>&nbsp;编辑</el-button>
                <el-button type="text" size="small" @click="remove(scope.row.id)"><i class="el-icon-delete"></i>&nbsp;删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 添加/编辑录音员 -->
        <el-dialog :visible.sync="addOrUpdateVisible" width="750px" :class="['recorder-dialog', 'arco-style']" :close-on-click-modal="false">
          <span slot="title" class="dialog-title-wrapper">
            <span class="dialog-title">{{ title }}</span>
            <span style="width: 70px;"></span>
          </span>
          <div class="recorder-form-container">
            <el-form size="small" label-width="120px" class="recorder-form">
              <el-form-item label="名字">
                <el-input placeholder="请输入录音员名字" v-model="addReq.name" class="form-input"/>
              </el-form-item>
              <el-form-item label="类型">
                <el-select v-model="addReq.supplierCode" filterable placeholder="请选择" class="form-select" onchange="supplierCodeChange">
                  <el-option
                    v-for="item in supplierCodeOption"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="录音员类型" v-if="addReq.supplierCode === 1007">
                <el-select v-model="addReq.actorType" filterable  placeholder="请选择录音员类型" class="form-select">
                  <el-option key="v1" label="1.0音色" value="v1">
                  </el-option>
                  <el-option key="v2" label="2.0音色" value="v2">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="编码">
                <el-input placeholder="请输入录音编码" v-model="addReq.recorderNo" class="form-input"/>
              </el-form-item>
              <el-form-item label="性别" v-if="addReq.supplierCode !== 1009">
                <el-select v-model="addReq.gender" filterable placeholder="请选择" class="form-select">
                  <el-option
                    v-for="item in genderList"
                    :key="item.value"
                    :label="item.value"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="语速" v-if="addReq.supplierCode !== 1004 && addReq.supplierCode !== 1009">
                <el-input placeholder="请输入录音语速，范围是-500~500" v-model="addReq.speechRate" class="form-input"/>
              </el-form-item>
              <el-form-item label="语调" v-if="addReq.supplierCode !== 1004 && addReq.supplierCode !== 1009">
                <el-input placeholder="请输入录音语调，范围是-500~500" v-model="addReq.pitchRate" class="form-input"/>
              </el-form-item>
              <el-form-item label="音量" v-if="addReq.supplierCode === 1010">
                <el-input type="number" :min="0" :max="100" placeholder="请输入音量，范围是0~100" v-model="addReq.volume" class="form-input"/>
              </el-form-item>
              <el-form-item label="语言类型" v-if="addReq.supplierCode === 1006 || addReq.supplierCode === 1008">
                <el-input placeholder="请输入录音员语言类型" v-model="addReq.languageType" class="form-input"/>
              </el-form-item>
              <el-form-item label="辅助文本" v-if="addReq.supplierCode === 1007 && addReq.actorType === 'v2'">
                <el-input placeholder="请输入辅助文本" type="textarea" v-model="addReq.auxiliaryText" :rows="4" :maxlength="32" show-word-limit resize="none"/>
              </el-form-item>
              <!-- 音频模版区域 -->
              <template v-if="addReq.supplierCode === 1004">
                <el-form-item label="音频模版">
                  <template>
                    <span v-if="addReq.templatePath">
                      <el-button icon="el-icon-service" @click="showButton(addReq)" v-if="addReq.showAddress === false" class="audio-display-btn">{{ addReq.templateOriginalName }}</el-button>
                      <div v-if="addReq.showAddress === true" v-loading="addReq.voiceLoading" class="audio-player" :id="'myAudio'+addReq.id"></div>
                    </span>
                    <span v-else class="placeholder-text">--</span>
                  </template>
                </el-form-item>
                <el-form-item label="">
                  <el-upload
                    class="upload-demo"
                    ref="upload"
                    action="#"
                    multiple
                    :limit="1"
                    :on-change="fileChanged"
                    accept=".wav,.mp3,.m4a"
                    :show-file-list="false"
                    :auto-upload="false"
                    :file-list="fileList.length===0?[]:fileList"
                  >
                    <el-button type="primary" icon="el-icon-upload" @click="upload()" class="upload-btn">
                      点击上传音频
                    </el-button>
                    <div class="help-tip">
                      <el-tooltip class="item" effect="light" placement="right">
                        <div slot="content">
                          只能上传.wav|.mp3|.m4a格式文件，且不超过20MB
                        </div>
                        <i class="el-icon-question"></i>
                      </el-tooltip>
                    </div>
                  </el-upload>
                </el-form-item>
              </template>

              <!-- 自建TTS-V2新增字段 -->
              <div v-if="addReq.supplierCode === 1009" class="tts-section">
                <div class="section-divider">
                  <span class="divider-text">TTS配置</span>
                </div>

                <el-form-item label="语种">
                  <el-select v-model="addReq.ext.language" placeholder="请选择" class="form-select" filterable>
                    <el-option
                      v-for="item in languageOption"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="生成方式">
                  <el-select v-model="addReq.ext.generationMode" placeholder="请选择" class="form-select">
                    <el-option
                      v-for="item in generationModeOption"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>

                <!-- 声音克隆相关字段 -->
                <div v-if="addReq.ext.generationMode === 'voiceClone'" class="sub-section">
                  <div class="sub-section-title">
                    <i class="el-icon-microphone"></i> 声音克隆配置
                  </div>
                  <el-form-item label="参考音频">
                    <template>
                      <span v-if="addReq.templatePath">
                        <el-button icon="el-icon-service" @click="showButton(addReq)" v-if="addReq.showAddress === false" class="audio-display-btn">{{ addReq.templateOriginalName }}</el-button>
                        <div v-if="addReq.showAddress === true" v-loading="addReq.voiceLoading" class="audio-player" :id="'myAudio'+addReq.id"></div>
                      </span>
                      <span v-else class="placeholder-text">--</span>
                      <el-tooltip class="item" effect="light" placement="top">
                        <div slot="content">
                          建议：3–10秒音频
                        </div>
                        <i class="el-icon-question" style="color: #909399; cursor: pointer; margin-left: 4px;"></i>
                      </el-tooltip>
                    </template>
                  </el-form-item>
                  <el-form-item label="">
                    <el-upload
                      class="upload-demo"
                      ref="upload"
                      action="#"
                      multiple
                      :limit="1"
                      :on-change="fileChanged"
                      accept=".wav,.mp3,.m4a"
                      :show-file-list="false"
                      :auto-upload="false"
                      :file-list="fileList.length===0?[]:fileList"
                    >
                      <el-button type="primary" icon="el-icon-upload" @click="upload()" class="upload-btn">
                        点击上传参考音频
                      </el-button>
                    </el-upload>
                  </el-form-item>
                  <el-form-item label="参考音频文本">
                    <el-input type="textarea" :rows="2" placeholder="请输入参考音频文本(可选)" v-model="addReq.ext.referenceText" class="form-textarea"/>
                  </el-form-item>
                  <el-form-item label="说明">
                    <el-input type="textarea" :rows="2" placeholder="请输入说明" v-model="addReq.ext.instruct" class="form-textarea"/>
                  </el-form-item>
                </div>

                <!-- 声音设计相关字段 -->
                <div v-if="addReq.ext.generationMode === 'voiceDesign'" class="sub-section">
                  <div class="sub-section-title">
                    <i class="el-icon-edit"></i> 声音设计配置
                  </div>
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <el-form-item label="性别">
                        <el-select v-model="addReq.ext.designGender" placeholder="请选择" class="form-select-full">
                          <el-option
                            v-for="item in designGenderOption"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="年龄">
                        <el-select v-model="addReq.ext.age" placeholder="请选择" class="form-select-full">
                          <el-option
                            v-for="item in ageOption"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <el-form-item label="音调">
                        <el-select v-model="addReq.ext.pitch" placeholder="请选择" class="form-select-full">
                          <el-option
                            v-for="item in pitchOption"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="风格">
                        <el-select v-model="addReq.ext.style" placeholder="请选择" class="form-select-full">
                          <el-option
                            v-for="item in styleOption"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-form-item label="英文口音" v-if="addReq.ext.language === 'English'">
                    <el-select v-model="addReq.ext.englishAccent" placeholder="请选择" class="form-select">
                      <el-option
                        v-for="item in englishAccentOption"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="中文方言" v-if="addReq.ext.language === 'Chinese'">
                    <el-select v-model="addReq.ext.chineseDialect" placeholder="请选择" class="form-select">
                      <el-option
                        v-for="item in chineseDialectOption"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>

                <!-- 生成设置 -->
                <div class="generation-settings">
                  <div class="settings-toggle" @click="generationSettingsCollapsed = !generationSettingsCollapsed">
                    <i :class="generationSettingsCollapsed ? 'el-icon-arrow-right' : 'el-icon-arrow-down'" class="toggle-icon"></i>
                    <span class="toggle-text">生成设置</span>
                    <div class="toggle-line"></div>
                  </div>
                  <div v-show="!generationSettingsCollapsed" class="settings-content">
                    <el-form-item label="语速">
                      <div class="slider-container">
                        <el-slider v-model="addReq.ext.speed" :min="0.5" :max="1.5" :step="0.01" :show-tooltip="true" class="form-slider"/>
                        <el-button type="text" icon="el-icon-refresh-left" @click="addReq.ext.speed = 1" class="reset-btn" title="恢复默认值"></el-button>
                      </div>
                    </el-form-item>
                    <el-form-item label="时长（秒）">
                      <el-input type="number" placeholder="请输入时长" v-model="addReq.ext.duration" class="form-input"/>
                    </el-form-item>
                    <el-form-item label="推理步数">
                      <div class="slider-container">
                        <el-slider v-model="addReq.ext.inferenceSteps" :min="0" :max="64" :step="1" :show-tooltip="true" class="form-slider"/>
                        <el-button type="text" icon="el-icon-refresh-left" @click="addReq.ext.inferenceSteps = 32" class="reset-btn" title="恢复默认值"></el-button>
                        <el-tooltip class="item" effect="light" placement="right">
                          <div slot="content">
                            数值越低，速度越快；数值越高，质量越好
                          </div>
                          <i class="el-icon-question help-icon"></i>
                        </el-tooltip>
                      </div>
                    </el-form-item>
                    <el-row :gutter="20">
                      <el-col :span="8">
                        <el-form-item label="去噪">
                          <el-switch v-model="addReq.ext.denoise"/>
                        </el-form-item>
                      </el-col>
                      <el-col :span="16">
                        <el-form-item label="引导比例（CFG）">
                          <div class="slider-container">
                            <el-slider v-model="addReq.ext.guidanceScale" :min="0" :max="4" :step="0.1" :show-tooltip="true" class="form-slider"/>
                            <el-button type="text" icon="el-icon-refresh-left" @click="addReq.ext.guidanceScale = 2" class="reset-btn" title="恢复默认值"></el-button>
                          </div>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row :gutter="20">
                      <el-col :span="12">
                        <el-form-item label="预处理提示">
                          <div class="switch-container">
                            <el-switch v-model="addReq.ext.preprocessPrompt"/>
                            <el-tooltip class="item" effect="light" placement="right">
                              <div slot="content">
                                对参考音频进行静音去除和修剪，在参考文本末尾添加标点符号（如果尚未添加）
                              </div>
                              <i class="el-icon-question help-icon"></i>
                            </el-tooltip>
                          </div>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="后处理输出">
                          <div class="switch-container">
                            <el-switch v-model="addReq.ext.postprocessOutput"/>
                            <el-tooltip class="item" effect="light" placement="right">
                              <div slot="content">
                                从生成的音频中移除长静音
                              </div>
                              <i class="el-icon-question help-icon"></i>
                            </el-tooltip>
                          </div>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </div>
                </div>
              </div>

              <el-form-item label="状态">
                <el-switch v-model="addReq.status" :active-value="1" :inactive-value="0"/>
              </el-form-item>
            </el-form>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="addOrUpdateVisible = false" class="cancel-btn">取 消</el-button>
            <el-button type="primary" @click="updateOrInsert" class="save-btn">保 存</el-button>
          </div>
          <!-- 进度条 -->
          <el-progress
            v-if="progressVisible"
            :percentage="progressPercent"
            class="progress-bar"
          ></el-progress>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      searchReq: {
        name: null
      },
      recorderlist: [],
      addReq: {
        id: null,
        gender: null,
        name: null,
        status: null,
        recorderNo: null,
        actorType: null,
        auxiliaryText: null,
        speechRate: null,
        pitchRate: null,
        volume: null,
        languageType: null,
        supplierCode: null,
        templatePath: null,
        templatePathTem: null,
        templateOriginalName: null,
        showAddress: false,
        ext: {
          generationMode: null,
          referenceText: null,
          instruct: null,
          gender: null,
          designGender: 'Auto',
          pitch: 'Auto',
          age: 'Auto',
          style: 'Auto',
          englishAccent: 'Auto',
          chineseDialect: 'Auto',
          language: 'Auto',
          speed: 1,
          duration: null,
          inferenceSteps: 32,
          denoise: true,
          guidanceScale: 2,
          preprocessPrompt: true,
          postprocessOutput: true
        }
      },
      genderList: [
        {
          value: '男'
        },
        {
          value: '女'
        }
      ],
      supplierCodeOption: [
        {
          value: 1000,
          label: 'XF'
        },
        {
          value: 1001,
          label: 'AL'
        },
        {
          value: 1010,
          label: '阿里-V2(流式语音)'
        },
        {
          value: 1002,
          label: 'WR'
        },
        {
          value: 1007,
          label: 'HS-V3'
        },
        {
          value: 1003,
          label: 'HS'
        },
        {
          value: 1004,
          label: 'ZJ'
        },
        {
          value: 1005,
          label: 'XF-noUpdate'
        },
        {
          value: 1006,
          label: 'Minimax'
        },
        {
          value: 1008,
          label: 'TX'
        }
        // ,
        // {
        //   value: 1009,
        //   label: '自建TTS-V2'
        // }
      ],
      generationModeOption: [
        {
          value: 'voiceClone',
          label: '声音克隆'
        },
        {
          value: 'voiceDesign',
          label: '声音设计'
        }
      ],
      designGenderOption: [
        {
          value: 'Auto',
          label: 'Auto'
        },
        {
          value: 'Male / 男',
          label: 'Male / 男'
        },
        {
          value: 'Female / 女',
          label: 'Female / 女'
        }
      ],
      ageOption: [
        {
          value: 'Auto',
          label: 'Auto'
        },
        {
          value: 'Child / 儿童',
          label: 'Child / 儿童'
        },
        {
          value: 'Teenager / 少年',
          label: 'Teenager / 少年'
        },
        {
          value: 'Young Adult / 青年',
          label: 'Young Adult / 青年'
        },
        {
          value: 'Middle-aged / 中年',
          label: 'Middle-aged / 中年'
        },
        {
          value: 'Elderly / 老年',
          label: 'Elderly / 老年'
        }
      ],
      pitchOption: [
        {
          value: 'Auto',
          label: 'Auto'
        },
        {
          value: 'Very Low Pitch / 极低音调',
          label: 'Very Low Pitch / 极低音调'
        },
        {
          value: 'Low Pitch / 低音调',
          label: 'Low Pitch / 低音调'
        },
        {
          value: 'Moderate Pitch / 中音调',
          label: 'Moderate Pitch / 中音调'
        },
        {
          value: 'High Pitch / 高音调',
          label: 'High Pitch / 高音调'
        },
        {
          value: 'Very High Pitch / 极高音调',
          label: 'Very High Pitch / 极高音调'
        }
      ],
      styleOption: [
        {
          value: 'Auto',
          label: 'Auto'
        },
        {
          value: 'Whisper / 耳语',
          label: 'Whisper / 耳语'
        }
      ],
      englishAccentOption: [
        {
          value: 'Auto',
          label: 'Auto'
        },
        {
          value: 'American Accent / 美式口音',
          label: 'American Accent / 美式口音'
        }
      ],
      chineseDialectOption: [
        {
          value: 'Auto',
          label: 'Auto'
        },
        {
          value: 'Henan Dialect / 河南话',
          label: 'Henan Dialect / 河南话'
        },
        {
          value: 'Shaanxi Dialect / 陕西话',
          label: 'Shaanxi Dialect / 陕西话'
        },
        {
          value: 'Sichuan Dialect / 四川话',
          label: 'Sichuan Dialect / 四川话'
        },
        {
          value: 'Guizhou Dialect / 贵州话',
          label: 'Guizhou Dialect / 贵州话'
        },
        {
          value: 'Yunnan Dialect / 云南话',
          label: 'Yunnan Dialect / 云南话'
        },
        {
          value: 'Guilin Dialect / 桂林话',
          label: 'Guilin Dialect / 桂林话'
        },
        {
          value: 'Jinan Dialect / 济南话',
          label: 'Jinan Dialect / 济南话'
        },
        {
          value: 'Shijiazhuang Dialect / 石家庄话',
          label: 'Shijiazhuang Dialect / 石家庄话'
        },
        {
          value: 'Gansu Dialect / 甘肃话',
          label: 'Gansu Dialect / 甘肃话'
        },
        {
          value: 'Ningxia Dialect / 宁夏话',
          label: 'Ningxia Dialect / 宁夏话'
        },
        {
          value: 'Qingdao Dialect / 青岛话',
          label: 'Qingdao Dialect / 青岛话'
        },
        {
          value: 'Northeast Dialect / 东北话',
          label: 'Northeast Dialect / 东北话'
        }
      ],
      languageOption: [
        {
          value: 'Auto',
          label: 'Auto'
        },
        {
          value: 'Abadi',
          label: 'Abadi'
        },
        {
          value: 'Abkhazian',
          label: 'Abkhazian'
        },
        {
          value: 'Abron',
          label: 'Abron'
        },
        {
          value: 'Abua',
          label: 'Abua'
        },
        {
          value: 'Adamawa Fulfulde',
          label: 'Adamawa Fulfulde'
        },
        {
          value: 'Adyghe',
          label: 'Adyghe'
        },
        {
          value: 'Afade',
          label: 'Afade'
        },
        {
          value: 'Afrikaans',
          label: 'Afrikaans'
        },
        {
          value: 'Agwagwune',
          label: 'Agwagwune'
        },
        {
          value: 'Aja (Benin)',
          label: 'Aja (Benin)'
        },
        {
          value: 'Akebu',
          label: 'Akebu'
        },
        {
          value: 'Alago',
          label: 'Alago'
        },
        {
          value: 'Albanian',
          label: 'Albanian'
        },
        {
          value: 'Algerian Arabic',
          label: 'Algerian Arabic'
        },
        {
          value: 'Algerian Saharan Arabic',
          label: 'Algerian Saharan Arabic'
        },
        {
          value: 'Ambo-Pasco Quechua',
          label: 'Ambo-Pasco Quechua'
        },
        {
          value: 'Ambonese Malay',
          label: 'Ambonese Malay'
        },
        {
          value: 'Amdo Tibetan',
          label: 'Amdo Tibetan'
        },
        {
          value: 'Amharic',
          label: 'Amharic'
        },
        {
          value: 'Anaang',
          label: 'Anaang'
        },
        {
          value: 'Angika',
          label: 'Angika'
        },
        {
          value: 'Antankarana Malagasy',
          label: 'Antankarana Malagasy'
        },
        {
          value: 'Aragonese',
          label: 'Aragonese'
        },
        {
          value: 'Arbëreshë Albanian',
          label: 'Arbëreshë Albanian'
        },
        {
          value: 'Arequipa-La Unión Quechua',
          label: 'Arequipa-La Unión Quechua'
        },
        {
          value: 'Armenian',
          label: 'Armenian'
        },
        {
          value: 'Ashe',
          label: 'Ashe'
        },
        {
          value: 'Ashéninka Perené',
          label: 'Ashéninka Perené'
        },
        {
          value: 'Askopan',
          label: 'Askopan'
        },
        {
          value: 'Assamese',
          label: 'Assamese'
        },
        {
          value: 'Asturian',
          label: 'Asturian'
        },
        {
          value: 'Atayal',
          label: 'Atayal'
        },
        {
          value: 'Awak',
          label: 'Awak'
        },
        {
          value: 'Ayacucho Quechua',
          label: 'Ayacucho Quechua'
        },
        {
          value: 'Azerbaijani',
          label: 'Azerbaijani'
        },
        {
          value: 'Baatonum',
          label: 'Baatonum'
        },
        {
          value: 'Bacama',
          label: 'Bacama'
        },
        {
          value: 'Bade',
          label: 'Bade'
        },
        {
          value: 'Bafia',
          label: 'Bafia'
        },
        {
          value: 'Bafut',
          label: 'Bafut'
        },
        {
          value: 'Bagirmi Fulfulde',
          label: 'Bagirmi Fulfulde'
        },
        {
          value: 'Bago-Kusuntu',
          label: 'Bago-Kusuntu'
        },
        {
          value: 'Baharna Arabic',
          label: 'Baharna Arabic'
        },
        {
          value: 'Bakoko',
          label: 'Bakoko'
        },
        {
          value: 'Balanta-Ganja',
          label: 'Balanta-Ganja'
        },
        {
          value: 'Balti',
          label: 'Balti'
        },
        {
          value: 'Bamenyam',
          label: 'Bamenyam'
        },
        {
          value: 'Bamun',
          label: 'Bamun'
        },
        {
          value: 'Bangwinji',
          label: 'Bangwinji'
        },
        {
          value: 'Banjar',
          label: 'Banjar'
        },
        {
          value: 'Bankon',
          label: 'Bankon'
        },
        {
          value: 'Baoulé',
          label: 'Baoulé'
        },
        {
          value: 'Bara Malagasy',
          label: 'Bara Malagasy'
        },
        {
          value: 'Barok',
          label: 'Barok'
        },
        {
          value: 'Basa (Cameroon)',
          label: 'Basa (Cameroon)'
        },
        {
          value: 'Basa (Nigeria)',
          label: 'Basa (Nigeria)'
        },
        {
          value: 'Bashkir',
          label: 'Bashkir'
        },
        {
          value: 'Basque',
          label: 'Basque'
        },
        {
          value: 'Batak Mandailing',
          label: 'Batak Mandailing'
        },
        {
          value: 'Batanga',
          label: 'Batanga'
        },
        {
          value: 'Bateri',
          label: 'Bateri'
        },
        {
          value: 'Bats',
          label: 'Bats'
        },
        {
          value: 'Bayot',
          label: 'Bayot'
        },
        {
          value: 'Bebele',
          label: 'Bebele'
        },
        {
          value: 'Belarusian',
          label: 'Belarusian'
        },
        {
          value: 'Bengali',
          label: 'Bengali'
        },
        {
          value: 'Betawi',
          label: 'Betawi'
        },
        {
          value: 'Bhili',
          label: 'Bhili'
        },
        {
          value: 'Bhojpuri',
          label: 'Bhojpuri'
        },
        {
          value: 'Bilur',
          label: 'Bilur'
        },
        {
          value: 'Bima',
          label: 'Bima'
        },
        {
          value: 'Bodo',
          label: 'Bodo'
        },
        {
          value: 'Boghom',
          label: 'Boghom'
        },
        {
          value: 'Bokyi',
          label: 'Bokyi'
        },
        {
          value: 'Bomu',
          label: 'Bomu'
        },
        {
          value: 'Bondei',
          label: 'Bondei'
        },
        {
          value: 'Borgu Fulfulde',
          label: 'Borgu Fulfulde'
        },
        {
          value: 'Bosnian',
          label: 'Bosnian'
        },
        {
          value: 'Brahui',
          label: 'Brahui'
        },
        {
          value: 'Braj',
          label: 'Braj'
        },
        {
          value: 'Breton',
          label: 'Breton'
        },
        {
          value: 'Buduma',
          label: 'Buduma'
        },
        {
          value: 'Buginese',
          label: 'Buginese'
        },
        {
          value: 'Bukharic',
          label: 'Bukharic'
        },
        {
          value: 'Bulgarian',
          label: 'Bulgarian'
        },
        {
          value: 'Bulu (Cameroon)',
          label: 'Bulu (Cameroon)'
        },
        {
          value: 'Bundeli',
          label: 'Bundeli'
        },
        {
          value: 'Bunun',
          label: 'Bunun'
        },
        {
          value: 'Bura-Pabir',
          label: 'Bura-Pabir'
        },
        {
          value: 'Burak',
          label: 'Burak'
        },
        {
          value: 'Burmese',
          label: 'Burmese'
        },
        {
          value: 'Burushaski',
          label: 'Burushaski'
        },
        {
          value: 'Cacaloxtepec Mixtec',
          label: 'Cacaloxtepec Mixtec'
        },
        {
          value: 'Cajatambo North Lima Quechua',
          label: 'Cajatambo North Lima Quechua'
        },
        {
          value: 'Cakfem-Mushere',
          label: 'Cakfem-Mushere'
        },
        {
          value: 'Cameroon Pidgin',
          label: 'Cameroon Pidgin'
        },
        {
          value: 'Campidanese Sardinian',
          label: 'Campidanese Sardinian'
        },
        {
          value: 'Cantonese',
          label: 'Cantonese'
        },
        {
          value: 'Catalan',
          label: 'Catalan'
        },
        {
          value: 'Cebuano',
          label: 'Cebuano'
        },
        {
          value: 'Cen',
          label: 'Cen'
        },
        {
          value: 'Central Kurdish',
          label: 'Central Kurdish'
        },
        {
          value: 'Central Nahuatl',
          label: 'Central Nahuatl'
        },
        {
          value: 'Central Pame',
          label: 'Central Pame'
        },
        {
          value: 'Central Pashto',
          label: 'Central Pashto'
        },
        {
          value: 'Central Puebla Nahuatl',
          label: 'Central Puebla Nahuatl'
        },
        {
          value: 'Central Tarahumara',
          label: 'Central Tarahumara'
        },
        {
          value: 'Central Yupik',
          label: 'Central Yupik'
        },
        {
          value: 'Central-Eastern Niger Fulfulde',
          label: 'Central-Eastern Niger Fulfulde'
        },
        {
          value: 'Chadian Arabic',
          label: 'Chadian Arabic'
        },
        {
          value: 'Chichewa',
          label: 'Chichewa'
        },
        {
          value: 'Chichicapan Zapotec',
          label: 'Chichicapan Zapotec'
        },
        {
          value: 'Chiga',
          label: 'Chiga'
        },
        {
          value: 'Chimalapa Zoque',
          label: 'Chimalapa Zoque'
        },
        {
          value: 'Chimborazo Highland Quichua',
          label: 'Chimborazo Highland Quichua'
        },
        {
          value: 'Chinese',
          label: 'Chinese'
        },
        {
          value: 'Chiquián Ancash Quechua',
          label: 'Chiquián Ancash Quechua'
        },
        {
          value: 'Chitwania Tharu',
          label: 'Chitwania Tharu'
        },
        {
          value: 'Chokwe',
          label: 'Chokwe'
        },
        {
          value: 'Chuvash',
          label: 'Chuvash'
        },
        {
          value: 'Cibak',
          label: 'Cibak'
        },
        {
          value: 'Coastal Konjo',
          label: 'Coastal Konjo'
        },
        {
          value: 'Copainalá Zoque',
          label: 'Copainalá Zoque'
        },
        {
          value: 'Cornish',
          label: 'Cornish'
        },
        {
          value: 'Corongo Ancash Quechua',
          label: 'Corongo Ancash Quechua'
        },
        {
          value: 'Croatian',
          label: 'Croatian'
        },
        {
          value: 'Cross River Mbembe',
          label: 'Cross River Mbembe'
        },
        {
          value: 'Cuyamecalco Mixtec',
          label: 'Cuyamecalco Mixtec'
        },
        {
          value: 'Czech',
          label: 'Czech'
        },
        {
          value: 'Dadiya',
          label: 'Dadiya'
        },
        {
          value: 'Dagbani',
          label: 'Dagbani'
        },
        {
          value: 'Dameli',
          label: 'Dameli'
        },
        {
          value: 'Danish',
          label: 'Danish'
        },
        {
          value: 'Dargwa',
          label: 'Dargwa'
        },
        {
          value: 'Dazaga',
          label: 'Dazaga'
        },
        {
          value: 'Deccan',
          label: 'Deccan'
        },
        {
          value: 'Degema',
          label: 'Degema'
        },
        {
          value: 'Dera (Nigeria)',
          label: 'Dera (Nigeria)'
        },
        {
          value: 'Dghwede',
          label: 'Dghwede'
        },
        {
          value: 'Dhatki',
          label: 'Dhatki'
        },
        {
          value: 'Dhivehi',
          label: 'Dhivehi'
        },
        {
          value: 'Dhofari Arabic',
          label: 'Dhofari Arabic'
        },
        {
          value: 'Dijim-Bwilim',
          label: 'Dijim-Bwilim'
        },
        {
          value: 'Dogri',
          label: 'Dogri'
        },
        {
          value: 'Domaaki',
          label: 'Domaaki'
        },
        {
          value: 'Dotyali',
          label: 'Dotyali'
        },
        {
          value: 'Duala',
          label: 'Duala'
        },
        {
          value: 'Dutch',
          label: 'Dutch'
        },
        {
          value: 'DũYa',
          label: 'DũYa'
        },
        {
          value: 'Dyula',
          label: 'Dyula'
        },
        {
          value: 'Eastern Balochi',
          label: 'Eastern Balochi'
        },
        {
          value: 'Eastern Bolivian Guaraní',
          label: 'Eastern Bolivian Guaraní'
        },
        {
          value: 'Eastern Egyptian Bedawi Arabic',
          label: 'Eastern Egyptian Bedawi Arabic'
        },
        {
          value: 'Eastern Krahn',
          label: 'Eastern Krahn'
        },
        {
          value: 'Eastern Mari',
          label: 'Eastern Mari'
        },
        {
          value: 'Eastern Yiddish',
          label: 'Eastern Yiddish'
        },
        {
          value: 'Ebrié',
          label: 'Ebrié'
        },
        {
          value: 'Eggon',
          label: 'Eggon'
        },
        {
          value: 'Egyptian Arabic',
          label: 'Egyptian Arabic'
        },
        {
          value: 'Ejagham',
          label: 'Ejagham'
        },
        {
          value: 'Eleme',
          label: 'Eleme'
        },
        {
          value: 'Eloyi',
          label: 'Eloyi'
        },
        {
          value: 'Embu',
          label: 'Embu'
        },
        {
          value: 'English',
          label: 'English'
        },
        {
          value: 'Erzya',
          label: 'Erzya'
        },
        {
          value: 'Esan',
          label: 'Esan'
        },
        {
          value: 'Esperanto',
          label: 'Esperanto'
        },
        {
          value: 'Estonian',
          label: 'Estonian'
        },
        {
          value: 'Eton (Cameroon)',
          label: 'Eton (Cameroon)'
        },
        {
          value: 'Ewondo',
          label: 'Ewondo'
        },
        {
          value: 'Extremaduran',
          label: 'Extremaduran'
        },
        {
          value: 'Fang (Equatorial Guinea)',
          label: 'Fang (Equatorial Guinea)'
        },
        {
          value: 'Fanti',
          label: 'Fanti'
        },
        {
          value: 'Farefare',
          label: 'Farefare'
        },
        {
          value: 'Fe\'fe\'',
          label: 'Fe\'fe\''
        },
        {
          value: 'Filipino',
          label: 'Filipino'
        },
        {
          value: 'Filomena Mata-Coahuitlán Totonac',
          label: 'Filomena Mata-Coahuitlán Totonac'
        },
        {
          value: 'Finnish',
          label: 'Finnish'
        },
        {
          value: 'Fipa',
          label: 'Fipa'
        },
        {
          value: 'French',
          label: 'French'
        },
        {
          value: 'Fulah',
          label: 'Fulah'
        },
        {
          value: 'Galician',
          label: 'Galician'
        },
        {
          value: 'Gambian Wolof',
          label: 'Gambian Wolof'
        },
        {
          value: 'Ganda',
          label: 'Ganda'
        },
        {
          value: 'Garhwali',
          label: 'Garhwali'
        },
        {
          value: 'Gawar-Bati',
          label: 'Gawar-Bati'
        },
        {
          value: 'Gawri',
          label: 'Gawri'
        },
        {
          value: 'Gbagyi',
          label: 'Gbagyi'
        },
        {
          value: 'Gbari',
          label: 'Gbari'
        },
        {
          value: 'Geji',
          label: 'Geji'
        },
        {
          value: 'Gen',
          label: 'Gen'
        },
        {
          value: 'Georgian',
          label: 'Georgian'
        },
        {
          value: 'German',
          label: 'German'
        },
        {
          value: 'Geser-Gorom',
          label: 'Geser-Gorom'
        },
        {
          value: 'Gheg Albanian',
          label: 'Gheg Albanian'
        },
        {
          value: 'Ghomálá\'',
          label: 'Ghomálá\''
        },
        {
          value: 'Gidar',
          label: 'Gidar'
        },
        {
          value: 'Glavda',
          label: 'Glavda'
        },
        {
          value: 'Goan Konkani',
          label: 'Goan Konkani'
        },
        {
          value: 'Goaria',
          label: 'Goaria'
        },
        {
          value: 'Goemai',
          label: 'Goemai'
        },
        {
          value: 'Gola',
          label: 'Gola'
        },
        {
          value: 'Greek',
          label: 'Greek'
        },
        {
          value: 'Guarani',
          label: 'Guarani'
        },
        {
          value: 'Guduf-Gava',
          label: 'Guduf-Gava'
        },
        {
          value: 'Guerrero Amuzgo',
          label: 'Guerrero Amuzgo'
        },
        {
          value: 'Gujarati',
          label: 'Gujarati'
        },
        {
          value: 'Gujari',
          label: 'Gujari'
        },
        {
          value: 'Gulf Arabic',
          label: 'Gulf Arabic'
        },
        {
          value: 'Gurgula',
          label: 'Gurgula'
        },
        {
          value: 'Gusii',
          label: 'Gusii'
        },
        {
          value: 'Gusilay',
          label: 'Gusilay'
        },
        {
          value: 'Gweno',
          label: 'Gweno'
        },
        {
          value: 'Güilá Zapotec',
          label: 'Güilá Zapotec'
        },
        {
          value: 'Hadothi',
          label: 'Hadothi'
        },
        {
          value: 'Hahon',
          label: 'Hahon'
        },
        {
          value: 'Haitian',
          label: 'Haitian'
        },
        {
          value: 'Hakha Chin',
          label: 'Hakha Chin'
        },
        {
          value: 'Hakö',
          label: 'Hakö'
        },
        {
          value: 'Halia',
          label: 'Halia'
        },
        {
          value: 'Hausa',
          label: 'Hausa'
        },
        {
          value: 'Hawaiian',
          label: 'Hawaiian'
        },
        {
          value: 'Hazaragi',
          label: 'Hazaragi'
        },
        {
          value: 'Hebrew',
          label: 'Hebrew'
        },
        {
          value: 'Hemba',
          label: 'Hemba'
        },
        {
          value: 'Herero',
          label: 'Herero'
        },
        {
          value: 'Highland Konjo',
          label: 'Highland Konjo'
        },
        {
          value: 'Hijazi Arabic',
          label: 'Hijazi Arabic'
        },
        {
          value: 'Hindi',
          label: 'Hindi'
        },
        {
          value: 'Huarijio',
          label: 'Huarijio'
        },
        {
          value: 'Huautla Mazatec',
          label: 'Huautla Mazatec'
        },
        {
          value: 'Huaxcaleca Nahuatl',
          label: 'Huaxcaleca Nahuatl'
        },
        {
          value: 'Huba',
          label: 'Huba'
        },
        {
          value: 'Huitepec Mixtec',
          label: 'Huitepec Mixtec'
        },
        {
          value: 'Hula',
          label: 'Hula'
        },
        {
          value: 'Hungarian',
          label: 'Hungarian'
        },
        {
          value: 'Hunjara-Kaina Ke',
          label: 'Hunjara-Kaina Ke'
        },
        {
          value: 'Hwana',
          label: 'Hwana'
        },
        {
          value: 'Ibibio',
          label: 'Ibibio'
        },
        {
          value: 'Icelandic',
          label: 'Icelandic'
        },
        {
          value: 'Idakho-Isukha-Tiriki',
          label: 'Idakho-Isukha-Tiriki'
        },
        {
          value: 'Idoma',
          label: 'Idoma'
        },
        {
          value: 'Igbo',
          label: 'Igbo'
        },
        {
          value: 'Igo',
          label: 'Igo'
        },
        {
          value: 'Ikposo',
          label: 'Ikposo'
        },
        {
          value: 'Ikwere',
          label: 'Ikwere'
        },
        {
          value: 'Imbabura Highland Quichua',
          label: 'Imbabura Highland Quichua'
        },
        {
          value: 'Indonesian',
          label: 'Indonesian'
        },
        {
          value: 'Indus Kohistani',
          label: 'Indus Kohistani'
        },
        {
          value: 'Interlingua (International Auxiliary Language Association)',
          label: 'Interlingua (International Auxiliary Language Association)'
        },
        {
          value: 'Inupiaq',
          label: 'Inupiaq'
        },
        {
          value: 'Irish',
          label: 'Irish'
        },
        {
          value: 'Iron Ossetic',
          label: 'Iron Ossetic'
        },
        {
          value: 'Isekiri',
          label: 'Isekiri'
        },
        {
          value: 'Isoko',
          label: 'Isoko'
        },
        {
          value: 'Italian',
          label: 'Italian'
        },
        {
          value: 'Ito',
          label: 'Ito'
        },
        {
          value: 'Itzá',
          label: 'Itzá'
        },
        {
          value: 'Ixtayutla Mixtec',
          label: 'Ixtayutla Mixtec'
        },
        {
          value: 'Izon',
          label: 'Izon'
        },
        {
          value: 'Jambi Malay',
          label: 'Jambi Malay'
        },
        {
          value: 'Japanese',
          label: 'Japanese'
        },
        {
          value: 'Jaqaru',
          label: 'Jaqaru'
        },
        {
          value: 'Jauja Wanca Quechua',
          label: 'Jauja Wanca Quechua'
        },
        {
          value: 'Jaunsari',
          label: 'Jaunsari'
        },
        {
          value: 'Javanese',
          label: 'Javanese'
        },
        {
          value: 'Jiba',
          label: 'Jiba'
        },
        {
          value: 'Jju',
          label: 'Jju'
        },
        {
          value: 'Judeo-Moroccan Arabic',
          label: 'Judeo-Moroccan Arabic'
        },
        {
          value: 'Juxtlahuaca Mixtec',
          label: 'Juxtlahuaca Mixtec'
        },
        {
          value: 'Kabardian',
          label: 'Kabardian'
        },
        {
          value: 'Kabras',
          label: 'Kabras'
        },
        {
          value: 'Kabuverdianu',
          label: 'Kabuverdianu'
        },
        {
          value: 'Kabyle',
          label: 'Kabyle'
        },
        {
          value: 'Kachi Koli',
          label: 'Kachi Koli'
        },
        {
          value: 'Kairak',
          label: 'Kairak'
        },
        {
          value: 'Kalabari',
          label: 'Kalabari'
        },
        {
          value: 'Kalasha',
          label: 'Kalasha'
        },
        {
          value: 'Kalenjin',
          label: 'Kalenjin'
        },
        {
          value: 'Kalkoti',
          label: 'Kalkoti'
        },
        {
          value: 'Kamba',
          label: 'Kamba'
        },
        {
          value: 'Kamo',
          label: 'Kamo'
        },
        {
          value: 'Kanauji',
          label: 'Kanauji'
        },
        {
          value: 'Kanembu',
          label: 'Kanembu'
        },
        {
          value: 'Kannada',
          label: 'Kannada'
        },
        {
          value: 'Karekare',
          label: 'Karekare'
        },
        {
          value: 'Kashmiri',
          label: 'Kashmiri'
        },
        {
          value: 'Kathoriya Tharu',
          label: 'Kathoriya Tharu'
        },
        {
          value: 'Kati',
          label: 'Kati'
        },
        {
          value: 'Kazakh',
          label: 'Kazakh'
        },
        {
          value: 'Keiyo',
          label: 'Keiyo'
        },
        {
          value: 'Khams Tibetan',
          label: 'Khams Tibetan'
        },
        {
          value: 'Khana',
          label: 'Khana'
        },
        {
          value: 'Khetrani',
          label: 'Khetrani'
        },
        {
          value: 'Khmer',
          label: 'Khmer'
        },
        {
          value: 'Khowar',
          label: 'Khowar'
        },
        {
          value: 'Kinga',
          label: 'Kinga'
        },
        {
          value: 'Kinnauri',
          label: 'Kinnauri'
        },
        {
          value: 'Kinyarwanda',
          label: 'Kinyarwanda'
        },
        {
          value: 'Kirghiz',
          label: 'Kirghiz'
        },
        {
          value: 'Kirya-Konzəl',
          label: 'Kirya-Konzəl'
        },
        {
          value: 'Kochila Tharu',
          label: 'Kochila Tharu'
        },
        {
          value: 'Kohistani Shina',
          label: 'Kohistani Shina'
        },
        {
          value: 'Kohumono',
          label: 'Kohumono'
        },
        {
          value: 'Kok Borok',
          label: 'Kok Borok'
        },
        {
          value: 'Kol (Papua New Guinea)',
          label: 'Kol (Papua New Guinea)'
        },
        {
          value: 'Kom (Cameroon)',
          label: 'Kom (Cameroon)'
        },
        {
          value: 'Koma',
          label: 'Koma'
        },
        {
          value: 'Konkani',
          label: 'Konkani'
        },
        {
          value: 'Konzo',
          label: 'Konzo'
        },
        {
          value: 'Korean',
          label: 'Korean'
        },
        {
          value: 'Korwa',
          label: 'Korwa'
        },
        {
          value: 'Kota (India)',
          label: 'Kota (India)'
        },
        {
          value: 'Koti',
          label: 'Koti'
        },
        {
          value: 'Kuanua',
          label: 'Kuanua'
        },
        {
          value: 'Kuanyama',
          label: 'Kuanyama'
        },
        {
          value: 'Kui (India)',
          label: 'Kui (India)'
        },
        {
          value: 'Kulung (Nigeria)',
          label: 'Kulung (Nigeria)'
        },
        {
          value: 'Kuot',
          label: 'Kuot'
        },
        {
          value: 'Kushi',
          label: 'Kushi'
        },
        {
          value: 'Kwambi',
          label: 'Kwambi'
        },
        {
          value: 'Kwasio',
          label: 'Kwasio'
        },
        {
          value: 'Lala-Roba',
          label: 'Lala-Roba'
        },
        {
          value: 'Lamang',
          label: 'Lamang'
        },
        {
          value: 'Lao',
          label: 'Lao'
        },
        {
          value: 'Larike-Wakasihu',
          label: 'Larike-Wakasihu'
        },
        {
          value: 'Lasi',
          label: 'Lasi'
        },
        {
          value: 'Latgalian',
          label: 'Latgalian'
        },
        {
          value: 'Latvian',
          label: 'Latvian'
        },
        {
          value: 'Levantine Arabic',
          label: 'Levantine Arabic'
        },
        {
          value: 'Liana-Seti',
          label: 'Liana-Seti'
        },
        {
          value: 'Liberia Kpelle',
          label: 'Liberia Kpelle'
        },
        {
          value: 'Liberian English',
          label: 'Liberian English'
        },
        {
          value: 'Libyan Arabic',
          label: 'Libyan Arabic'
        },
        {
          value: 'Ligurian',
          label: 'Ligurian'
        },
        {
          value: 'Lijili',
          label: 'Lijili'
        },
        {
          value: 'Lingala',
          label: 'Lingala'
        },
        {
          value: 'Lithuanian',
          label: 'Lithuanian'
        },
        {
          value: 'Loarki',
          label: 'Loarki'
        },
        {
          value: 'Logooli',
          label: 'Logooli'
        },
        {
          value: 'Logudorese Sardinian',
          label: 'Logudorese Sardinian'
        },
        {
          value: 'Loja Highland Quichua',
          label: 'Loja Highland Quichua'
        },
        {
          value: 'Loloda',
          label: 'Loloda'
        },
        {
          value: 'Longuda',
          label: 'Longuda'
        },
        {
          value: 'Loxicha Zapotec',
          label: 'Loxicha Zapotec'
        },
        {
          value: 'Luba-Lulua',
          label: 'Luba-Lulua'
        },
        {
          value: 'Luo',
          label: 'Luo'
        },
        {
          value: 'Lushai',
          label: 'Lushai'
        },
        {
          value: 'Luxembourgish',
          label: 'Luxembourgish'
        },
        {
          value: 'Maasina Fulfulde',
          label: 'Maasina Fulfulde'
        },
        {
          value: 'Maba (Chad)',
          label: 'Maba (Chad)'
        },
        {
          value: 'Macedo-Romanian',
          label: 'Macedo-Romanian'
        },
        {
          value: 'Macedonian',
          label: 'Macedonian'
        },
        {
          value: 'Mada (Cameroon)',
          label: 'Mada (Cameroon)'
        },
        {
          value: 'Mafa',
          label: 'Mafa'
        },
        {
          value: 'Maithili',
          label: 'Maithili'
        },
        {
          value: 'Malay',
          label: 'Malay'
        },
        {
          value: 'Malayalam',
          label: 'Malayalam'
        },
        {
          value: 'Mali',
          label: 'Mali'
        },
        {
          value: 'Malinaltepec Me\'phaa',
          label: 'Malinaltepec Me\'phaa'
        },
        {
          value: 'Maltese',
          label: 'Maltese'
        },
        {
          value: 'Mandara',
          label: 'Mandara'
        },
        {
          value: 'Mandjak',
          label: 'Mandjak'
        },
        {
          value: 'Manggarai',
          label: 'Manggarai'
        },
        {
          value: 'Manipuri',
          label: 'Manipuri'
        },
        {
          value: 'Mansoanka',
          label: 'Mansoanka'
        },
        {
          value: 'Manx',
          label: 'Manx'
        },
        {
          value: 'Maori',
          label: 'Maori'
        },
        {
          value: 'Marathi',
          label: 'Marathi'
        },
        {
          value: 'Marghi Central',
          label: 'Marghi Central'
        },
        {
          value: 'Marghi South',
          label: 'Marghi South'
        },
        {
          value: 'Maria (India)',
          label: 'Maria (India)'
        },
        {
          value: 'Marwari (Pakistan)',
          label: 'Marwari (Pakistan)'
        },
        {
          value: 'Masana',
          label: 'Masana'
        },
        {
          value: 'Masikoro Malagasy',
          label: 'Masikoro Malagasy'
        },
        {
          value: 'Matsés',
          label: 'Matsés'
        },
        {
          value: 'Mazaltepec Zapotec',
          label: 'Mazaltepec Zapotec'
        },
        {
          value: 'Mazatlán Mazatec',
          label: 'Mazatlán Mazatec'
        },
        {
          value: 'Mazatlán Mixe',
          label: 'Mazatlán Mixe'
        },
        {
          value: 'Mbe',
          label: 'Mbe'
        },
        {
          value: 'Mbo (Cameroon)',
          label: 'Mbo (Cameroon)'
        },
        {
          value: 'Mbum',
          label: 'Mbum'
        },
        {
          value: 'Medumba',
          label: 'Medumba'
        },
        {
          value: 'Mekeo',
          label: 'Mekeo'
        },
        {
          value: 'Meru',
          label: 'Meru'
        },
        {
          value: 'Mesopotamian Arabic',
          label: 'Mesopotamian Arabic'
        },
        {
          value: 'Mewari',
          label: 'Mewari'
        },
        {
          value: 'Min Nan Chinese',
          label: 'Min Nan Chinese'
        },
        {
          value: 'Mingrelian',
          label: 'Mingrelian'
        },
        {
          value: 'Mitlatongo Mixtec',
          label: 'Mitlatongo Mixtec'
        },
        {
          value: 'Miya',
          label: 'Miya'
        },
        {
          value: 'Mokpwe',
          label: 'Mokpwe'
        },
        {
          value: 'Moksha',
          label: 'Moksha'
        },
        {
          value: 'Mom Jango',
          label: 'Mom Jango'
        },
        {
          value: 'Mongolian',
          label: 'Mongolian'
        },
        {
          value: 'Moroccan Arabic',
          label: 'Moroccan Arabic'
        },
        {
          value: 'Motu',
          label: 'Motu'
        },
        {
          value: 'Mpiemo',
          label: 'Mpiemo'
        },
        {
          value: 'Mpumpong',
          label: 'Mpumpong'
        },
        {
          value: 'Mundang',
          label: 'Mundang'
        },
        {
          value: 'Mungaka',
          label: 'Mungaka'
        },
        {
          value: 'Musey',
          label: 'Musey'
        },
        {
          value: 'Musgu',
          label: 'Musgu'
        },
        {
          value: 'Musi',
          label: 'Musi'
        },
        {
          value: 'Naba',
          label: 'Naba'
        },
        {
          value: 'Najdi Arabic',
          label: 'Najdi Arabic'
        },
        {
          value: 'Nalik',
          label: 'Nalik'
        },
        {
          value: 'Nawdm',
          label: 'Nawdm'
        },
        {
          value: 'Ndonga',
          label: 'Ndonga'
        },
        {
          value: 'Neapolitan',
          label: 'Neapolitan'
        },
        {
          value: 'Nepali',
          label: 'Nepali'
        },
        {
          value: 'Ngamo',
          label: 'Ngamo'
        },
        {
          value: 'Ngas',
          label: 'Ngas'
        },
        {
          value: 'Ngiemboon',
          label: 'Ngiemboon'
        },
        {
          value: 'Ngizim',
          label: 'Ngizim'
        },
        {
          value: 'Ngomba',
          label: 'Ngomba'
        },
        {
          value: 'Ngombale',
          label: 'Ngombale'
        },
        {
          value: 'Nigerian Fulfulde',
          label: 'Nigerian Fulfulde'
        },
        {
          value: 'Nigerian Pidgin',
          label: 'Nigerian Pidgin'
        },
        {
          value: 'Nimadi',
          label: 'Nimadi'
        },
        {
          value: 'Nobiin',
          label: 'Nobiin'
        },
        {
          value: 'North Mesopotamian Arabic',
          label: 'North Mesopotamian Arabic'
        },
        {
          value: 'North Moluccan Malay',
          label: 'North Moluccan Malay'
        },
        {
          value: 'Northern Betsimisaraka Malagasy',
          label: 'Northern Betsimisaraka Malagasy'
        },
        {
          value: 'Northern Hindko',
          label: 'Northern Hindko'
        },
        {
          value: 'Northern Kurdish',
          label: 'Northern Kurdish'
        },
        {
          value: 'Northern Pame',
          label: 'Northern Pame'
        },
        {
          value: 'Northern Pashto',
          label: 'Northern Pashto'
        },
        {
          value: 'Northern Uzbek',
          label: 'Northern Uzbek'
        },
        {
          value: 'Northwest Gbaya',
          label: 'Northwest Gbaya'
        },
        {
          value: 'Norwegian',
          label: 'Norwegian'
        },
        {
          value: 'Norwegian Bokmål',
          label: 'Norwegian Bokmål'
        },
        {
          value: 'Norwegian Nynorsk',
          label: 'Norwegian Nynorsk'
        },
        {
          value: 'Notsi',
          label: 'Notsi'
        },
        {
          value: 'Nyankpa',
          label: 'Nyankpa'
        },
        {
          value: 'Nyungwe',
          label: 'Nyungwe'
        },
        {
          value: 'Nzanyi',
          label: 'Nzanyi'
        },
        {
          value: 'Nüpode Huitoto',
          label: 'Nüpode Huitoto'
        },
        {
          value: 'Occitan',
          label: 'Occitan'
        },
        {
          value: 'Od',
          label: 'Od'
        },
        {
          value: 'Odia',
          label: 'Odia'
        },
        {
          value: 'Odual',
          label: 'Odual'
        },
        {
          value: 'Omani Arabic',
          label: 'Omani Arabic'
        },
        {
          value: 'Orizaba Nahuatl',
          label: 'Orizaba Nahuatl'
        },
        {
          value: 'Orma',
          label: 'Orma'
        },
        {
          value: 'Ormuri',
          label: 'Ormuri'
        },
        {
          value: 'Oromo',
          label: 'Oromo'
        },
        {
          value: 'Pahari-Potwari',
          label: 'Pahari-Potwari'
        },
        {
          value: 'Paiwan',
          label: 'Paiwan'
        },
        {
          value: 'Panjabi',
          label: 'Panjabi'
        },
        {
          value: 'Papuan Malay',
          label: 'Papuan Malay'
        },
        {
          value: 'Parkari Koli',
          label: 'Parkari Koli'
        },
        {
          value: 'Pedi',
          label: 'Pedi'
        },
        {
          value: 'Pero',
          label: 'Pero'
        },
        {
          value: 'Persian',
          label: 'Persian'
        },
        {
          value: 'Petats',
          label: 'Petats'
        },
        {
          value: 'Phalura',
          label: 'Phalura'
        },
        {
          value: 'Piemontese',
          label: 'Piemontese'
        },
        {
          value: 'Piya-Kwonci',
          label: 'Piya-Kwonci'
        },
        {
          value: 'Plateau Malagasy',
          label: 'Plateau Malagasy'
        },
        {
          value: 'Polish',
          label: 'Polish'
        },
        {
          value: 'Poqomam',
          label: 'Poqomam'
        },
        {
          value: 'Portuguese',
          label: 'Portuguese'
        },
        {
          value: 'Pulaar',
          label: 'Pulaar'
        },
        {
          value: 'Pular',
          label: 'Pular'
        },
        {
          value: 'Puno Quechua',
          label: 'Puno Quechua'
        },
        {
          value: 'Pushto',
          label: 'Pushto'
        },
        {
          value: 'Pökoot',
          label: 'Pökoot'
        },
        {
          value: 'Qaqet',
          label: 'Qaqet'
        },
        {
          value: 'Quiotepec Chinantec',
          label: 'Quiotepec Chinantec'
        },
        {
          value: 'Rana Tharu',
          label: 'Rana Tharu'
        },
        {
          value: 'Rangi',
          label: 'Rangi'
        },
        {
          value: 'Rapoisi',
          label: 'Rapoisi'
        },
        {
          value: 'Ratahan',
          label: 'Ratahan'
        },
        {
          value: 'Rayón Zoque',
          label: 'Rayón Zoque'
        },
        {
          value: 'Romanian',
          label: 'Romanian'
        },
        {
          value: 'Romansh',
          label: 'Romansh'
        },
        {
          value: 'Rombo',
          label: 'Rombo'
        },
        {
          value: 'Rotokas',
          label: 'Rotokas'
        },
        {
          value: 'Rukai',
          label: 'Rukai'
        },
        {
          value: 'Russian',
          label: 'Russian'
        },
        {
          value: 'Sacapulteco',
          label: 'Sacapulteco'
        },
        {
          value: 'Saidi Arabic',
          label: 'Saidi Arabic'
        },
        {
          value: 'Sakalava Malagasy',
          label: 'Sakalava Malagasy'
        },
        {
          value: 'Sakizaya',
          label: 'Sakizaya'
        },
        {
          value: 'Saleman',
          label: 'Saleman'
        },
        {
          value: 'Samba Daka',
          label: 'Samba Daka'
        },
        {
          value: 'Samba Leko',
          label: 'Samba Leko'
        },
        {
          value: 'San Felipe Otlaltepec Popoloca',
          label: 'San Felipe Otlaltepec Popoloca'
        },
        {
          value: 'San Francisco Del Mar Huave',
          label: 'San Francisco Del Mar Huave'
        },
        {
          value: 'San Juan Atzingo Popoloca',
          label: 'San Juan Atzingo Popoloca'
        },
        {
          value: 'San Martín Itunyoso Triqui',
          label: 'San Martín Itunyoso Triqui'
        },
        {
          value: 'San Miguel El Grande Mixtec',
          label: 'San Miguel El Grande Mixtec'
        },
        {
          value: 'Sansi',
          label: 'Sansi'
        },
        {
          value: 'Sanskrit',
          label: 'Sanskrit'
        },
        {
          value: 'Santa Ana de Tusi Pasco Quechua',
          label: 'Santa Ana de Tusi Pasco Quechua'
        },
        {
          value: 'Santa Catarina Albarradas Zapotec',
          label: 'Santa Catarina Albarradas Zapotec'
        },
        {
          value: 'Santali',
          label: 'Santali'
        },
        {
          value: 'Santiago del Estero Quichua',
          label: 'Santiago del Estero Quichua'
        },
        {
          value: 'Saposa',
          label: 'Saposa'
        },
        {
          value: 'Saraiki',
          label: 'Saraiki'
        },
        {
          value: 'Sardinian',
          label: 'Sardinian'
        },
        {
          value: 'Saya',
          label: 'Saya'
        },
        {
          value: 'Sediq',
          label: 'Sediq'
        },
        {
          value: 'Serbian',
          label: 'Serbian'
        },
        {
          value: 'Seri',
          label: 'Seri'
        },
        {
          value: 'Shina',
          label: 'Shina'
        },
        {
          value: 'Shona',
          label: 'Shona'
        },
        {
          value: 'Siar-Lak',
          label: 'Siar-Lak'
        },
        {
          value: 'Sibe',
          label: 'Sibe'
        },
        {
          value: 'Sicilian',
          label: 'Sicilian'
        },
        {
          value: 'Sihuas Ancash Quechua',
          label: 'Sihuas Ancash Quechua'
        },
        {
          value: 'Sikkimese',
          label: 'Sikkimese'
        },
        {
          value: 'Sinaugoro',
          label: 'Sinaugoro'
        },
        {
          value: 'Sindhi',
          label: 'Sindhi'
        },
        {
          value: 'Sindhi Bhil',
          label: 'Sindhi Bhil'
        },
        {
          value: 'Sinhala',
          label: 'Sinhala'
        },
        {
          value: 'Sinicahua Mixtec',
          label: 'Sinicahua Mixtec'
        },
        {
          value: 'Sipacapense',
          label: 'Sipacapense'
        },
        {
          value: 'Siwai',
          label: 'Siwai'
        },
        {
          value: 'Slovak',
          label: 'Slovak'
        },
        {
          value: 'Slovenian',
          label: 'Slovenian'
        },
        {
          value: 'Solos',
          label: 'Solos'
        },
        {
          value: 'Somali',
          label: 'Somali'
        },
        {
          value: 'Soninke',
          label: 'Soninke'
        },
        {
          value: 'South Giziga',
          label: 'South Giziga'
        },
        {
          value: 'South Ucayali Ashéninka',
          label: 'South Ucayali Ashéninka'
        },
        {
          value: 'Southeastern Nochixtlán Mixtec',
          label: 'Southeastern Nochixtlán Mixtec'
        },
        {
          value: 'Southern Betsimisaraka Malagasy',
          label: 'Southern Betsimisaraka Malagasy'
        },
        {
          value: 'Southern Pashto',
          label: 'Southern Pashto'
        },
        {
          value: 'Southern Pastaza Quechua',
          label: 'Southern Pastaza Quechua'
        },
        {
          value: 'Soyaltepec Mazatec',
          label: 'Soyaltepec Mazatec'
        },
        {
          value: 'Spanish',
          label: 'Spanish'
        },
        {
          value: 'Standard Arabic',
          label: 'Standard Arabic'
        },
        {
          value: 'Standard Moroccan Tamazight',
          label: 'Standard Moroccan Tamazight'
        },
        {
          value: 'Sudanese Arabic',
          label: 'Sudanese Arabic'
        },
        {
          value: 'Sulka',
          label: 'Sulka'
        },
        {
          value: 'Svan',
          label: 'Svan'
        },
        {
          value: 'Swahili',
          label: 'Swahili'
        },
        {
          value: 'Swedish',
          label: 'Swedish'
        },
        {
          value: 'Tae\'',
          label: 'Tae\''
        },
        {
          value: 'Tahaggart Tamahaq',
          label: 'Tahaggart Tamahaq'
        },
        {
          value: 'Taita',
          label: 'Taita'
        },
        {
          value: 'Tajik',
          label: 'Tajik'
        },
        {
          value: 'Tamil',
          label: 'Tamil'
        },
        {
          value: 'Tandroy-Mahafaly Malagasy',
          label: 'Tandroy-Mahafaly Malagasy'
        },
        {
          value: 'Tangale',
          label: 'Tangale'
        },
        {
          value: 'Tanosy Malagasy',
          label: 'Tanosy Malagasy'
        },
        {
          value: 'Tarok',
          label: 'Tarok'
        },
        {
          value: 'Tatar',
          label: 'Tatar'
        },
        {
          value: 'Tedaga',
          label: 'Tedaga'
        },
        {
          value: 'Telugu',
          label: 'Telugu'
        },
        {
          value: 'Tem',
          label: 'Tem'
        },
        {
          value: 'Teop',
          label: 'Teop'
        },
        {
          value: 'Tepeuxila Cuicatec',
          label: 'Tepeuxila Cuicatec'
        },
        {
          value: 'Tepinapa Chinantec',
          label: 'Tepinapa Chinantec'
        },
        {
          value: 'Tera',
          label: 'Tera'
        },
        {
          value: 'Terei',
          label: 'Terei'
        },
        {
          value: 'Termanu',
          label: 'Termanu'
        },
        {
          value: 'Tesaka Malagasy',
          label: 'Tesaka Malagasy'
        },
        {
          value: 'Tetelcingo Nahuatl',
          label: 'Tetelcingo Nahuatl'
        },
        {
          value: 'Teutila Cuicatec',
          label: 'Teutila Cuicatec'
        },
        {
          value: 'Thai',
          label: 'Thai'
        },
        {
          value: 'Tibetan',
          label: 'Tibetan'
        },
        {
          value: 'Tidaá Mixtec',
          label: 'Tidaá Mixtec'
        },
        {
          value: 'Tidore',
          label: 'Tidore'
        },
        {
          value: 'Tigak',
          label: 'Tigak'
        },
        {
          value: 'Tigre',
          label: 'Tigre'
        },
        {
          value: 'Tigrinya',
          label: 'Tigrinya'
        },
        {
          value: 'Tilquiapan Zapotec',
          label: 'Tilquiapan Zapotec'
        },
        {
          value: 'Tinputz',
          label: 'Tinputz'
        },
        {
          value: 'Tlacoapa Me\'phaa',
          label: 'Tlacoapa Me\'phaa'
        },
        {
          value: 'Tlacoatzintepec Chinantec',
          label: 'Tlacoatzintepec Chinantec'
        },
        {
          value: 'Tlingit',
          label: 'Tlingit'
        },
        {
          value: 'Toki Pona',
          label: 'Toki Pona'
        },
        {
          value: 'Tomoip',
          label: 'Tomoip'
        },
        {
          value: 'Tondano',
          label: 'Tondano'
        },
        {
          value: 'Tonsea',
          label: 'Tonsea'
        },
        {
          value: 'Tooro',
          label: 'Tooro'
        },
        {
          value: 'Torau',
          label: 'Torau'
        },
        {
          value: 'Torwali',
          label: 'Torwali'
        },
        {
          value: 'Tsimihety Malagasy',
          label: 'Tsimihety Malagasy'
        },
        {
          value: 'Tsotso',
          label: 'Tsotso'
        },
        {
          value: 'Tswana',
          label: 'Tswana'
        },
        {
          value: 'Tugen',
          label: 'Tugen'
        },
        {
          value: 'Tuki',
          label: 'Tuki'
        },
        {
          value: 'Tula',
          label: 'Tula'
        },
        {
          value: 'Tulu',
          label: 'Tulu'
        },
        {
          value: 'Tunen',
          label: 'Tunen'
        },
        {
          value: 'Tungag',
          label: 'Tungag'
        },
        {
          value: 'Tunisian Arabic',
          label: 'Tunisian Arabic'
        },
        {
          value: 'Tupuri',
          label: 'Tupuri'
        },
        {
          value: 'Turkana',
          label: 'Turkana'
        },
        {
          value: 'Turkish',
          label: 'Turkish'
        },
        {
          value: 'Turkmen',
          label: 'Turkmen'
        },
        {
          value: 'Tututepec Mixtec',
          label: 'Tututepec Mixtec'
        },
        {
          value: 'Twi',
          label: 'Twi'
        },
        {
          value: 'Ubaghara',
          label: 'Ubaghara'
        },
        {
          value: 'Uighur',
          label: 'Uighur'
        },
        {
          value: 'Ukrainian',
          label: 'Ukrainian'
        },
        {
          value: 'Umbundu',
          label: 'Umbundu'
        },
        {
          value: 'Upper Sorbian',
          label: 'Upper Sorbian'
        },
        {
          value: 'Urdu',
          label: 'Urdu'
        },
        {
          value: 'Ushojo',
          label: 'Ushojo'
        },
        {
          value: 'Uzbek',
          label: 'Uzbek'
        },
        {
          value: 'Vai',
          label: 'Vai'
        },
        {
          value: 'Vietnamese',
          label: 'Vietnamese'
        },
        {
          value: 'Votic',
          label: 'Votic'
        },
        {
          value: 'Võro',
          label: 'Võro'
        },
        {
          value: 'Waci Gbe',
          label: 'Waci Gbe'
        },
        {
          value: 'Wadiyara Koli',
          label: 'Wadiyara Koli'
        },
        {
          value: 'Waja',
          label: 'Waja'
        },
        {
          value: 'Wakhi',
          label: 'Wakhi'
        },
        {
          value: 'Wanga',
          label: 'Wanga'
        },
        {
          value: 'Wapan',
          label: 'Wapan'
        },
        {
          value: 'Warji',
          label: 'Warji'
        },
        {
          value: 'Welsh',
          label: 'Welsh'
        },
        {
          value: 'Wemale',
          label: 'Wemale'
        },
        {
          value: 'Western Frisian',
          label: 'Western Frisian'
        },
        {
          value: 'Western Highland Purepecha',
          label: 'Western Highland Purepecha'
        },
        {
          value: 'Western Juxtlahuaca Mixtec',
          label: 'Western Juxtlahuaca Mixtec'
        },
        {
          value: 'Western Maninkakan',
          label: 'Western Maninkakan'
        },
        {
          value: 'Western Mari',
          label: 'Western Mari'
        },
        {
          value: 'Western Niger Fulfulde',
          label: 'Western Niger Fulfulde'
        },
        {
          value: 'Western Panjabi',
          label: 'Western Panjabi'
        },
        {
          value: 'Wolof',
          label: 'Wolof'
        },
        {
          value: 'Wuzlam',
          label: 'Wuzlam'
        },
        {
          value: 'Xanaguía Zapotec',
          label: 'Xanaguía Zapotec'
        },
        {
          value: 'Xhosa',
          label: 'Xhosa'
        },
        {
          value: 'Yace',
          label: 'Yace'
        },
        {
          value: 'Yakut',
          label: 'Yakut'
        },
        {
          value: 'Yalahatan',
          label: 'Yalahatan'
        },
        {
          value: 'Yanahuanca Pasco Quechua',
          label: 'Yanahuanca Pasco Quechua'
        },
        {
          value: 'Yangben',
          label: 'Yangben'
        },
        {
          value: 'Yaqui',
          label: 'Yaqui'
        },
        {
          value: 'Yauyos Quechua',
          label: 'Yauyos Quechua'
        },
        {
          value: 'Yekhee',
          label: 'Yekhee'
        },
        {
          value: 'Yiddish',
          label: 'Yiddish'
        },
        {
          value: 'Yidgha',
          label: 'Yidgha'
        },
        {
          value: 'Yoruba',
          label: 'Yoruba'
        },
        {
          value: 'Yutanduchi Mixtec',
          label: 'Yutanduchi Mixtec'
        },
        {
          value: 'Zacatlán-Ahuacatlán-Tepetzintla Nahuatl',
          label: 'Zacatlán-Ahuacatlán-Tepetzintla Nahuatl'
        },
        {
          value: 'Zarma',
          label: 'Zarma'
        },
        {
          value: 'Zaza',
          label: 'Zaza'
        },
        {
          value: 'Zulu',
          label: 'Zulu'
        },
        {
          value: 'Ömie',
          label: 'Ömie'
        }
      ],
      addOrUpdateVisible: false,
      title: null,
      fileList: [],
      progressVisible: false,
      progressPercent: 0,
      generationSettingsCollapsed: true
    };
  },
  methods: {
    addVisable() {
      this.title = '添加录音员';
      this.addReq.id = null;
      this.addReq.gender = null;
      this.addReq.name = null;
      this.addReq.status = null;
      this.addReq.recorderNo = null;
      this.addReq.actorType = null;
      this.addReq.auxiliaryText = null;
      this.addReq.speechRate = null;
      this.addReq.pitchRate = null;
      this.addReq.volume = null;
      this.addReq.languageType = null;
      this.addReq.supplierCode = null;
      this.addReq.templatePath = null;
      this.addReq.templateOriginalName = null;
      this.addReq.ext.generationMode = null;
      this.addReq.ext.referenceText = null;
      this.addReq.ext.instruct = null;
      this.addReq.ext.designGender = 'Auto';
      this.addReq.ext.age = 'Auto';
      this.addReq.ext.pitch = 'Auto';
      this.addReq.ext.style = 'Auto';
      this.addReq.ext.englishAccent = 'Auto';
      this.addReq.ext.chineseDialect = 'Auto';
      this.addReq.ext.language = 'Auto';
      this.addReq.ext.speed = 1;
      this.addReq.ext.duration = null;
      this.addReq.ext.inferenceSteps = 32;
      this.addReq.ext.denoise = true;
      this.addReq.ext.guidanceScale = 2;
      this.addReq.ext.preprocessPrompt = true;
      this.addReq.ext.postprocessOutput = true;
      this.addOrUpdateVisible = true;
      this.addReq.showAddress = false;
    },
    updateVisiable(row) {
      console.warn(row);
      this.title = '编辑录音员';
      console.warn(row);
      this.addReq.id = row.id;
      this.addReq.gender = row.gender;
      this.addReq.name = row.name;
      this.addReq.status = row.status;
      this.addReq.recorderNo = row.recorderNo;
      this.addReq.actorType = row.actorType;
      this.addReq.auxiliaryText = row.auxiliaryText;
      this.addReq.speechRate = row.speechRate;
      this.addReq.pitchRate = row.pitchRate;
      this.addReq.volume = row.volume || null;
      this.addReq.languageType = row.languageType;
      this.addReq.supplierCode = row.supplierCode;
      this.addReq.templatePath = row.templatePath || null;
      this.addReq.templateOriginalName = row.templateOriginalName || null;
      this.addReq.ext.generationMode = (row.ext && row.ext.generationMode) || null;
      this.addReq.ext.referenceText = (row.ext && row.ext.referenceText) || null;
      this.addReq.ext.instruct = (row.ext && row.ext.instruct) || null;
      this.addReq.ext.designGender = (row.ext && row.ext.designGender) || 'Auto';
      this.addReq.ext.pitch = (row.ext && row.ext.pitch) || 'Auto';
      this.addReq.ext.age = (row.ext && row.ext.age) || 'Auto';
      this.addReq.ext.style = (row.ext && row.ext.style) || 'Auto';
      this.addReq.ext.englishAccent = (row.ext && row.ext.englishAccent) || 'Auto';
      this.addReq.ext.chineseDialect = (row.ext && row.ext.chineseDialect) || 'Auto';
      this.addReq.ext.language = (row.ext && row.ext.language) || 'Auto';
      this.addReq.ext.speed = row.ext && (row.ext.speed !== undefined && row.ext.speed !== null) ? row.ext.speed : 1;
      this.addReq.ext.duration = (row.ext && row.ext.duration) || null;
      this.addReq.ext.inferenceSteps = row.ext && (row.ext.inferenceSteps !== undefined && row.ext.inferenceSteps !== null) ? row.ext.inferenceSteps : 32;
      this.addReq.ext.denoise = row.ext && (row.ext.denoise !== undefined && row.ext.denoise !== null) ? row.ext.denoise : true;
      this.addReq.ext.guidanceScale = row.ext && (row.ext.guidanceScale !== undefined && row.ext.guidanceScale !== null) ? row.ext.guidanceScale : 2;
      this.addReq.ext.preprocessPrompt = row.ext && (row.ext.preprocessPrompt !== undefined && row.ext.preprocessPrompt !== null) ? row.ext.preprocessPrompt : true;
      this.addReq.ext.postprocessOutput = row.ext && (row.ext.postprocessPrompt !== undefined && row.ext.postprocessOutput !== null) ? row.ext.postprocessOutput : true;
      this.generationSettingsCollapsed = true;
      this.addOrUpdateVisible = true;
      this.addReq.showAddress = false;
    },
    updateOrInsert() {
      if (this.addReq.supplierCode === 1009) {
        if (!this.addReq.ext.generationMode) {
          this.$message.error('请选择生成方式！');
          return;
        }
        if (this.addReq.ext.generationMode === 'voiceClone' && !this.addReq.templatePath) {
          this.$message.error('声音克隆方式下，请上传参考音频！');
          return;
        }
        // 处理 gender 字段冗余
        const designGender = this.addReq.ext.designGender;
        if (designGender === 'Male / 男') {
          this.addReq.gender = '男';
        } else if (designGender === 'Female / 女') {
          this.addReq.gender = '女';
        } else {
          // Auto 或空，默认男
          this.addReq.gender = '男';
        }
      }
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.$ajax({
        prompt: true,
        method: 'POST',
        url: '/recorder/updateOrInsert',
        data: this.addReq
      }).then(() => {
        loading.close();
        this.getList();
        this.addOrUpdateVisible = false;
      }).catch(() => {
        loading.close();
        this.addOrUpdateVisible = true;
      });
    },
    remove(userId) {
      this.$confirm('您确定要删除该录音员吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$ajax({
          prompt: true,
          method: 'DELETE',
          url: `/recorder/remove/${userId}`
        }).then(() => {
          // 刷新
          this.getList();
        });
      });
    },
    getList() {
      this.$ajax({
        method: 'POST',
        url: '/recorder/list',
        data: this.searchReq
      }).then((res) => {
        this.recorderlist = res.data;
      });
    },
    // 上传音频
    fileChanged(file, fileList) {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.addReq.templatePathTem = null;
      this.addReq.templateOriginalName = null;
      this.addReq.templatePath = null;
      this.fileList = fileList;
      const FileExt = file.name.replace(/.+\./, '').toLowerCase();
      const wavFlag = ['wav'].includes(FileExt);
      const mp3Flag = ['mp3'].includes(FileExt);
      const m4aFlag = ['m4a'].includes(FileExt);
      const isLt10M = file.size / 1024 / 1024 < 20;
      if (!wavFlag && !mp3Flag && !m4aFlag) {
        this.$message.error('文件格式错误请重新上传!');
        this.fileList = [];
        loading.close();
      }
      if (!isLt10M) {
        this.$message.error('上传的文件大小不能超过 20MB!');
        this.fileList = [];
        loading.close();
      }
      const formData = new FormData();
      formData.append('file', this.fileList[0].raw);
      formData.append('type', 3);
      if ((wavFlag || mp3Flag || m4aFlag) && isLt10M) {
        this.$ajax({
          url: '/scene/recordUpload',
          method: 'POST',
          prompt: true,
          contentType: 'multipart/form-data',
          data: formData
        }).then((res) => {
          if (res.data) {
            const uploadedFile = res.data[0];
            const fileName = file.name.substring(file.name.lastIndexOf('/') + 1);
            const ai = {
              value: uploadedFile,
              label: fileName
            };
            this.fileList.push(ai);
            this.addReq.templatePathTem = ai.value;
            this.addReq.templateOriginalName = ai.label;
            this.addReq.templatePath = ai.value;
            this.addReq.showAddress = false;
          }
          loading.close();
        }).catch(() => {
          loading.close();
        });
      }
      return (wavFlag || mp3Flag || m4aFlag) && isLt10M;
    },
    upload() {
      // 先清空之前的文件
      this.fileList = [];
      this.$refs.upload.clearFiles();
    },
    showButton(scope) {
      scope.showAddress = true;
      this.auditionVoice(scope, scope.id, 'myAudio', 'templatePath', 'voiceLoading');
    },
    // 录音试听
    auditionVoice(row, index, elementIdPrefix, pathField, loadingField) {
      this.$set(row, loadingField, true);
      this.$downloadVoice({
        url: '/scene/getRecord',
        method: 'GET',
        responseType: 'blob',
        params: { 'address': row[pathField] }
      }).then((re) => {
        const blob = new Blob([re.data], { type: 'audio/wav' });
        const href = window.URL.createObjectURL(blob);
        const frameAudio = document.createElement('audio');
        frameAudio.controls = true;
        frameAudio.src = href;
        frameAudio.style = 'height: 30px;width: 180px;outline: none;';
        const bodyFa = document.getElementById(`${elementIdPrefix}${index}`);
        bodyFa.appendChild(frameAudio);
      }).finally(() => {
        this.$set(row, loadingField, false);
      });
    }

  },
  mounted() {
    this.getList();
  }
};
</script>

<style scoped>
/* 标题栏样式 */
.dialog-title-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.dialog-title {
  font-weight: 600;
  width: 70px;
  text-align: left;
}

/* 切换按钮样式 */
.style-toggle-btn {
  padding: 4px 12px;
  font-size: 13px;
  border-radius: 14px;
  transition: all 0.2s ease-in-out;
  color: #1d2129 !important;
}

.style-toggle-btn i {
  margin-right: 4px;
}

.style-toggle-btn.to-arco {
  background: rgba(22, 93, 255, 0.1);
  border: 1px solid rgba(22, 93, 255, 0.3);
}

.style-toggle-btn.to-arco:hover {
  background: rgba(22, 93, 255, 0.2);
}

.style-toggle-btn.to-purple {
  background: rgba(102, 126, 234, 0.1);
  border: 1px solid rgba(102, 126, 234, 0.3);
}

.style-toggle-btn.to-purple:hover {
  background: rgba(102, 126, 234, 0.2);
}

/* =================== Arco Design 风格 =================== */
.arco-style {
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
}

.arco-style >>> .el-dialog__header {
  background: #ffffff;
  padding: 16px 24px;
  border-radius: 8px 8px 0 0;
  border-bottom: 1px solid #e5e6eb;
}

.arco-style >>> .el-dialog__headerbtn {
  top: 18px;
}

.arco-style >>> .el-dialog__headerbtn .el-dialog__close {
  color: #1d2129;
  font-size: 18px;
  background: #f2f3f5;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.arco-style >>> .el-dialog__headerbtn .el-dialog__close:hover {
  color: #1d2129;
  background: #e8ecf1;
}

.arco-style >>> .el-dialog__body {
  padding: 24px;
  max-height: 70vh;
  overflow-y: auto;
  background: #ffffff;
}

.arco-style .recorder-form >>> .el-form-item {
  margin-bottom: 22px;
}

.arco-style .recorder-form >>> .el-form-item__label {
  font-weight: 500;
  color: #4e5969;
  font-size: 14px;
  line-height: 22px;
}

.arco-style .form-input >>> .el-input__inner,
.arco-style .form-select >>> .el-input__inner {
  border-radius: 4px;
  border: 1px solid #c9cdd4;
  background: #ffffff;
  color: #1d2129;
  height: 36px;
  line-height: 36px;
  padding: 0 12px;
  font-size: 14px;
  transition: all 0.2s ease-in-out;
}

.arco-style .form-input >>> .el-input__inner:hover,
.arco-style .form-select >>> .el-input__inner:hover {
  border-color: #86909c;
}

.arco-style .form-input >>> .el-input__inner:focus,
.arco-style .form-select >>> .el-input__inner:focus {
  border-color: #165dff;
  box-shadow: 0 0 0 2px rgba(22, 93, 255, 0.1);
}

.arco-style .form-textarea >>> .el-textarea__inner {
  border-radius: 4px;
  border: 1px solid #c9cdd4;
  background: #ffffff;
  color: #1d2129;
  padding: 8px 12px;
  font-size: 14px;
  transition: all 0.2s ease-in-out;
  resize: vertical;
}

.arco-style .form-textarea >>> .el-textarea__inner:hover {
  border-color: #86909c;
}

.arco-style .form-textarea >>> .el-textarea__inner:focus {
  border-color: #165dff;
  box-shadow: 0 0 0 2px rgba(22, 93, 255, 0.1);
}

.arco-style .tts-section {
  background: #f7f8fa;
  border-radius: 6px;
  padding: 20px;
  margin-bottom: 20px;
  border: 1px solid #e5e6eb;
}

.arco-style .divider-text {
  display: inline-block;
  padding: 4px 16px;
  background: #e8f3ff;
  color: #165dff;
  font-size: 13px;
  font-weight: 500;
  border-radius: 12px;
}

.arco-style .sub-section {
  background: #ffffff;
  border-radius: 6px;
  padding: 20px;
  margin: 20px 0;
  border: 1px solid #e5e6eb;
}

.arco-style .sub-section-title {
  font-size: 14px;
  font-weight: 600;
  color: #1d2129;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  padding-bottom: 12px;
  border-bottom: 1px solid #e5e6eb;
}

.arco-style .sub-section-title i {
  margin-right: 8px;
  color: #165dff;
  font-size: 16px;
}

.arco-style .settings-toggle {
  display: flex;
  align-items: center;
  padding: 14px 16px;
  background: #ffffff;
  border: 1px solid #e5e6eb;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  margin-bottom: 12px;
}

.arco-style .settings-toggle:hover {
  border-color: #86909c;
  background: #f7f8fa;
}

.arco-style .toggle-icon {
  color: #4e5969;
  font-size: 14px;
  margin-right: 8px;
  transition: transform 0.2s ease-in-out;
}

.arco-style .toggle-text {
  font-weight: 500;
  color: #1d2129;
  font-size: 14px;
}

.arco-style .toggle-line {
  flex: 1;
  height: 1px;
  background: linear-gradient(to right, #e5e6eb, transparent);
  margin-left: 12px;
}

.arco-style .settings-content {
  background: #ffffff;
  border-radius: 6px;
  padding: 20px;
  border: 1px solid #e5e6eb;
  margin-top: -8px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.arco-style .form-slider >>> .el-slider__runway {
  background-color: #e5e6eb;
  height: 6px;
  border-radius: 3px;
}

.arco-style .form-slider >>> .el-slider__bar {
  background-color: #165dff;
  height: 6px;
  border-radius: 3px;
}

.arco-style .form-slider >>> .el-slider__button {
  border: 2px solid #165dff;
  background-color: #ffffff;
  width: 16px;
  height: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.arco-style .form-slider >>> .el-slider__button:hover {
  box-shadow: 0 4px 12px rgba(22, 93, 255, 0.2);
  transform: scale(1.1);
}

.arco-style .reset-btn {
  color: #4e5969;
  padding: 8px;
  transition: all 0.2s ease-in-out;
  border-radius: 4px;
}

.arco-style .reset-btn:hover {
  color: #165dff;
  background: rgba(22, 93, 255, 0.08);
}

.arco-style .switch-container >>> .el-switch.is-checked .el-switch__core {
  background-color: #165dff;
  border-color: #165dff;
}

.arco-style .switch-container >>> .el-switch__core {
  border-radius: 10px;
  height: 20px;
  width: 36px;
  background-color: #c9cdd4;
  border-color: #c9cdd4;
}

.arco-style .help-icon {
  color: #86909c;
  margin-left: 8px;
  font-size: 16px;
  cursor: help;
  transition: color 0.2s ease-in-out;
}

.arco-style .help-icon:hover {
  color: #165dff;
}

.arco-style .audio-display-btn {
  width: 100%;
  background: #ffffff;
  color: #165dff;
  border: 1px solid #165dff;
  border-radius: 4px;
  padding: 10px 16px;
  font-weight: 500;
  transition: all 0.2s ease-in-out;
}

.arco-style .audio-display-btn:hover {
  background: #e8f3ff;
  border-color: #0e42d2;
  color: #0e42d2;
}

.arco-style .audio-player {
  height: 40px;
  width: 100%;
  background: #f7f8fa;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #e5e6eb;
}

.arco-style .upload-btn {
  background: #165dff;
  border: none;
  border-radius: 4px;
  padding: 10px 20px;
  font-weight: 500;
  color: #ffffff;
  transition: all 0.2s ease-in-out;
}

.arco-style .upload-btn:hover {
  background: #0e42d2;
  box-shadow: 0 4px 12px rgba(22, 93, 255, 0.2);
}

.arco-style .upload-btn:active {
  background: #0a34a8;
}

.arco-style .placeholder-text {
  color: #86909c;
  font-size: 14px;
}

.arco-style .dialog-footer {
  padding: 16px 24px;
  background: #ffffff;
  border-top: 1px solid #e5e6eb;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  border-radius: 0 0 8px 8px;
}

.arco-style .cancel-btn {
  padding: 10px 24px;
  border-radius: 4px;
  font-weight: 500;
  border: 1px solid #c9cdd4;
  color: #4e5969;
  background: #ffffff;
  transition: all 0.2s ease-in-out;
}

.arco-style .cancel-btn:hover {
  color: #1d2129;
  border-color: #86909c;
  background: #f7f8fa;
}

.arco-style .save-btn {
  padding: 10px 24px;
  border-radius: 4px;
  font-weight: 500;
  background: #165dff;
  border: none;
  color: #ffffff;
  transition: all 0.2s ease-in-out;
}

.arco-style .save-btn:hover {
  background: #0e42d2;
  box-shadow: 0 4px 12px rgba(22, 93, 255, 0.2);
}

.arco-style .save-btn:active {
  background: #0a34a8;
}

.arco-style .progress-bar >>> .el-progress-bar__outer {
  background-color: #e5e6eb;
  border-radius: 3px;
  height: 6px;
}

.arco-style .progress-bar >>> .el-progress-bar__inner {
  background: linear-gradient(90deg, #165dff 0%, #23c3fc 100%);
  border-radius: 3px;
  height: 6px;
}

.arco-style >>> .el-dialog__body::-webkit-scrollbar {
  width: 6px;
}

.arco-style >>> .el-dialog__body::-webkit-scrollbar-track {
  background: #f2f3f5;
  border-radius: 3px;
}

.arco-style >>> .el-dialog__body::-webkit-scrollbar-thumb {
  background: #c9cdd4;
  border-radius: 3px;
}

.arco-style >>> .el-dialog__body::-webkit-scrollbar-thumb:hover {
  background: #86909c;
}

/* =================== 紫蓝渐变风格 =================== */
.purple-style {
  border-radius: 8px;
}

.purple-style >>> .el-dialog__header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 16px 24px;
  border-radius: 8px 8px 0 0;
}

.purple-style >>> .el-dialog__headerbtn {
  top: 18px;
}

.purple-style >>> .el-dialog__headerbtn .el-dialog__close {
  color: #1d2129;
  font-size: 20px;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.purple-style >>> .el-dialog__headerbtn .el-dialog__close:hover {
  color: #1d2129;
  background: rgba(255, 255, 255, 1);
}

.purple-style >>> .el-dialog__body {
  padding: 24px;
  max-height: 70vh;
  overflow-y: auto;
}

.purple-style .recorder-form >>> .el-form-item {
  margin-bottom: 20px;
}

.purple-style .recorder-form >>> .el-form-item__label {
  font-weight: 500;
  color: #303133;
  font-size: 14px;
}

.purple-style .tts-section {
  background: linear-gradient(to bottom, #f8faff, #ffffff);
  border-radius: 6px;
  padding: 16px;
  margin-bottom: 16px;
  border: 1px solid #e6ecf5;
}

.purple-style .divider-text {
  display: inline-block;
  padding: 0 16px;
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
  font-size: 13px;
  font-weight: 500;
  border-radius: 16px;
}

.purple-style .sub-section {
  background: white;
  border-radius: 6px;
  padding: 16px;
  margin: 16px 0;
  border: 1px solid #eff2f7;
}

.purple-style .sub-section-title {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  padding-bottom: 12px;
  border-bottom: 2px solid #f0f2f5;
}

.purple-style .sub-section-title i {
  margin-right: 8px;
  color: #667eea;
}

.purple-style .settings-toggle {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  background: linear-gradient(135deg, #f5f7fa 0%, #e8ecf1 100%);
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-bottom: 8px;
}

.purple-style .settings-toggle:hover {
  background: linear-gradient(135deg, #e8ecf1 0%, #dde3eb 100%);
}

.purple-style .toggle-icon {
  color: #667eea;
  font-size: 14px;
  margin-right: 8px;
  transition: transform 0.3s ease;
}

.purple-style .toggle-text {
  font-weight: 600;
  color: #303133;
  font-size: 14px;
}

.purple-style .toggle-line {
  flex: 1;
  height: 1px;
  background: linear-gradient(to right, #ccd0d5, transparent);
  margin-left: 12px;
}

.purple-style .settings-content {
  background: white;
  border-radius: 6px;
  padding: 16px;
  border: 1px solid #eff2f7;
  margin-top: -8px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.purple-style .form-slider >>> .el-slider__runway {
  background-color: #e5e6eb;
  height: 6px;
  border-radius: 3px;
}

.purple-style .form-slider >>> .el-slider__bar {
  background-color: #667eea;
  height: 6px;
  border-radius: 3px;
}

.purple-style .form-slider >>> .el-slider__button {
  border: 2px solid #667eea;
  background-color: #ffffff;
  width: 16px;
  height: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.purple-style .form-slider >>> .el-slider__button:hover {
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
  transform: scale(1.1);
}

.purple-style .reset-btn {
  color: #667eea;
  padding: 8px;
  transition: all 0.2s ease;
  border-radius: 4px;
}

.purple-style .reset-btn:hover {
  color: #764ba2;
  background: rgba(102, 126, 234, 0.1);
}

.purple-style .switch-container >>> .el-switch.is-checked .el-switch__core {
  background-color: #667eea;
  border-color: #667eea;
}

.purple-style .switch-container >>> .el-switch__core {
  border-radius: 10px;
  height: 20px;
  width: 36px;
  background-color: #c9cdd4;
  border-color: #c9cdd4;
}

.purple-style .help-icon {
  color: #86909c;
  margin-left: 8px;
  font-size: 16px;
  cursor: help;
  transition: color 0.2s ease;
}

.purple-style .help-icon:hover {
  color: #667eea;
}

.purple-style .audio-display-btn {
  width: 100%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 4px;
  padding: 10px 16px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.purple-style .audio-display-btn:hover {
  background: linear-gradient(135deg, #5a6fd6 0%, #6a4190 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.purple-style .audio-player {
  height: 40px;
  width: 100%;
  background: #f7f8fa;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #e5e6eb;
}

.purple-style .upload-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  border-radius: 4px;
  padding: 10px 20px;
  font-weight: 500;
  color: white;
  transition: all 0.3s ease;
}

.purple-style .upload-btn:hover {
  background: linear-gradient(135deg, #5a6fd6 0%, #6a4190 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.purple-style .placeholder-text {
  color: #86909c;
  font-size: 14px;
}

.purple-style .dialog-footer {
  padding: 20px 24px;
  background: #f7f8fa;
  border-top: 1px solid #e5e6eb;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  border-radius: 0 0 8px 8px;
}

.purple-style .cancel-btn {
  padding: 10px 24px;
  border-radius: 4px;
  font-weight: 500;
  border: 1px solid #dcdfe6;
  color: #606266;
  background: white;
  transition: all 0.2s ease;
}

.purple-style .cancel-btn:hover {
  color: #667eea;
  border-color: #667eea;
  background: rgba(102, 126, 234, 0.05);
}

.purple-style .save-btn {
  padding: 10px 24px;
  border-radius: 4px;
  font-weight: 500;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  color: white;
  transition: all 0.3s ease;
}

.purple-style .save-btn:hover {
  background: linear-gradient(135deg, #5a6fd6 0%, #6a4190 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.purple-style .progress-bar >>> .el-progress-bar__outer {
  background-color: #e5e6eb;
  border-radius: 3px;
  height: 6px;
}

.purple-style .progress-bar >>> .el-progress-bar__inner {
  background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);
  border-radius: 3px;
  height: 6px;
}

.purple-style >>> .el-dialog__body::-webkit-scrollbar {
  width: 6px;
}

.purple-style >>> .el-dialog__body::-webkit-scrollbar-track {
  background: #f2f3f5;
  border-radius: 3px;
}

.purple-style >>> .el-dialog__body::-webkit-scrollbar-thumb {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 3px;
}

.purple-style >>> .el-dialog__body::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(135deg, #5a6fd6 0%, #6a4190 100%);
}

/* 公共样式 */
.form-input,
.form-select {
  width: 100%;
}

.form-select-full {
  width: 100%;
}

.form-textarea {
  width: 100%;
}

.recorder-form-container {
  padding: 0;
}

.slider-container {
  display: flex;
  align-items: center;
  width: 100%;
}

.form-slider {
  flex: 1;
  margin-right: 12px;
}

.switch-container {
  display: flex;
  align-items: center;
}

.help-tip {
  display: inline-block;
  margin-left: 12px;
}

.progress-bar {
  margin: 0 24px 24px 24px;
}
</style>



// WEBPACK FOOTER //
// src/page/main/recorder/index.vue